export interface MappedIgError {
  friendly: string;
  raw: string;
}

// NOTE order matters — first match wins. Specific phrases before broad ones.
// `ig 400` is intentionally NOT a trigger: many distinct IG errors carry that
// prefix (restricted access, rate limit, ...), so matching it would mislabel.
const RULES: Array<{ test: RegExp; friendly: string }> = [
  { test: /user access is restricted|access token|oauth/i,
    friendly: 'Доступ к аккаунту ограничен (возможно сменён пароль) — переподключите аккаунт' },
  { test: /too many actions|performing too many|rate limit/i,
    friendly: 'Instagram временно ограничил действия аккаунта (слишком частые публикации) — подождите 10–15 минут и попробуйте снова' },
  // IG-side transient: its media downloader failed to fetch/process our hosted
  // video (5xx / timeout). Mirrors backend isInstagramTransientError. Must come
  // before the generic 'container processing failed' rule. Shown after the
  // backend has already exhausted its auto-retries — hence "try again later".
  { test: /container processing failed[\s\S]*(internal server error|video download failed|time(?:d)? ?out|http error code 5\d\d|media could not be fetched)/i,
    friendly: 'Instagram сейчас не принимает видео (ошибка на стороне Instagram) — повторите попытку через несколько минут' },
  { test: /container processing failed/i,
    friendly: 'Instagram не смог обработать медиа' },
  { test: /container processing timeout|not ready after/i,
    friendly: 'Instagram слишком долго обрабатывал — попробуйте позже' },
  { test: /failed to create media container/i,
    friendly: 'Не удалось отправить медиа в Instagram' },
  { test: /subcode.*33|code.*100/i,
    friendly: 'Медиафайл недоступен' },
  { test: /no video url/i,
    friendly: 'Видео не сгенерировалось' },
  { test: /cancelled-by-user/i,
    friendly: 'Отменено' },
  { test: /upload did not reach|upload connection failed|upload aborted/i,
    friendly: 'Загрузка видео не удалась — проверьте интернет и попробуйте ещё раз' },
];

export function mapIgError(raw: string | undefined | null): MappedIgError {
  const text = (raw ?? '').trim();
  if (!text) return { friendly: 'Неизвестная ошибка', raw: '' };
  const rule = RULES.find(r => r.test.test(text));
  return { friendly: rule ? rule.friendly : text, raw: text };
}
